import { nsSimCard } from '@/app/i18n/namespaces';
import SIM_CARDS_STATUS from '../enums/SimCardStatus';

export default {
    UUID: {
        key: 'uuid',
        enableSorting: false
    },
    CREATED_AT: {
        key: 'createdAt',
        type: 'date',
        entity: 'client_created_at'
    },
    UPDATED_AT: {
        key: 'updatedAt',
        type: 'date',
        entity: 'client_updated_at'
    },
    PROVIDER: {
        key: 'provider',
        LEGAL_NAME: {
            parentKeys: ['provider'],
            key: 'legalName',
            type: 'text',
            entity: 'keys.legal_name',
            namespace: nsSimCard
        }
    },
    CLIENT: {
        key: 'client',
        UUID: {
            parentKeys: ['client'],
            key: 'uuid'
        },
        PROVIDER: {
            parentKeys: ['client'],
            key: 'provider',
            type: 'text',
            entity: 'simCard_client_provider'
        },
        LEGAL_NAME: {
            parentKeys: ['client'],
            key: 'legalName',
            type: 'text',
            entity: 'keys.legal_name',
            namespace: nsSimCard,
            placeholder: 'filter.placeholder.legal_name',
            filter: 'input',
            enableSorting: true,
            isNested: true
        }
    },
    SIM_CARD: {
        key: 'sim',
        UUID: {
            parentKeys: ['sim'],
            key: 'uuid'
        },
        CREATED_AT: {
            parentKeys: ['sim'],
            key: 'createdAt',
            type: 'date',
            entity: 'keys.created_at',
            namespace: nsSimCard,
            filter: 'date',
            enableSorting: true,
            isNested: true
        },
        UPDATED_AT: {
            parentKeys: ['sim'],
            key: 'updatedAt',
            type: 'date',
            entity: 'keys.updated_at',
            namespace: nsSimCard,
            filter: 'date',
            enableSorting: true,
            isNested: true
        },
        LABEL: {
            parentKeys: ['sim'],
            key: 'label',
            type: 'text',
            entity: 'keys.label',
            namespace: nsSimCard,
            placeholder: 'filter.placeholder.label',
            filter: 'input',
            enableSorting: true,
            isNested: true
        },
        ICCID: {
            parentKeys: ['sim'],
            key: 'iccid',
            type: 'text',
            entity: 'keys.iccid',
            namespace: nsSimCard,
            placeholder: 'filter.placeholder.iccid',
            filter: 'input',
            enableSorting: true,
            isNested: true
        },
        ICCID_OPERATOR: {
            parentKeys: ['sim'],
            key: 'iccidOperator',
            type: 'text',
            entity: 'keys.operator',
            namespace: nsSimCard,
            isNested: true
        },
        STATUS: {
            parentKeys: ['sim'],
            key: 'status',
            type: 'badge',
            prefix: 'simCard_status_',
            entity: 'keys.status',
            namespace: nsSimCard,
            filter: 'select',
            enum: SIM_CARDS_STATUS,
            enableSorting: true,
            isNested: true
        },
        DATA: {
            parentKeys: ['sim'],
            key: 'tariffData',
            type: 'text',
            entity: 'keys.data',
            namespace: nsSimCard,
            filter: 'plan',
            enableSorting: true,
            isNested: true
        },
        DATA_UNIT: {
            parentKeys: ['sim'],
            key: 'tariffDataUnit',
            entity: 'keys.unit',
            type: 'text'
        },
        TARIFF_NAME: {
            parentKeys: ['sim'],
            key: 'tariffName',
            entity: 'tariff_name',
            type: 'text'
        },
        IP_ADDRESS: {
            parentKeys: ['sim'],
            key: 'ipAddress',
            entity: 'simCard_ip',
            type: 'text'
        },
        MNO_ACCOUNT_ID: {
            parentKeys: ['sim'],
            key: 'mnoAccountId',
            entity: 'simCard_mno_account_id',
            type: 'text'
        },
        MNO_ACCOUNT_NAME: {
            parentKeys: ['sim'],
            key: 'mnoAccountName',
            entity: 'simCard_mno_account_name',
            type: 'text'
        },
        MNO_ID: {
            parentKeys: ['sim'],
            key: 'mnoId',
            entity: 'simCard_mno_id',
            type: 'text'
        },
        MNO_NAME: {
            parentKeys: ['sim'],
            key: 'mnoName',
            entity: 'keys.mno_name',
            namespace: nsSimCard,
            type: 'text'
        },
        APNS: {
            parentKeys: ['sim'],
            key: 'apns',
            entity: 'keys.apns',
            namespace: nsSimCard,
            type: 'text'
        },
        ACTIVATION_DATE: {
            parentKeys: ['sim'],
            key: 'activationDate',
            type: 'dateNoTime',
            entity: 'keys.activation_date',
            namespace: nsSimCard,
            filter: 'date',
            enableSorting: true,
            isNested: true
        },
        ACTIVATION_REQUEST_DATE: {
            parentKeys: ['sim'],
            key: 'activationRequestDate',
            entity: 'keys.activation_request_date',
            namespace: nsSimCard,
            type: 'dateNoTime'
        },
        CANCELLATION_DATE: {
            parentKeys: ['sim'],
            key: 'cancellationDate',
            type: 'dateNoTime',
            entity: 'keys.cancellation_date',
            namespace: nsSimCard,
            filter: 'date',
            enableSorting: true,
            isNested: true
        },
        CANCELLATION_REQUEST_DATE: {
            parentKeys: ['sim'],
            key: 'cancellationRequestDate',
            entity: 'keys.cancellation_request_date',
            namespace: nsSimCard,
            type: 'dateNoTime'
        },
        BILLING_DATE: {
            parentKeys: ['sim'],
            key: 'billingStartDate',
            entity: 'simCard_billing_start_date',
            type: 'dateNoTime'
        },
        DISPATCH_DATE: {
            parentKeys: ['sim'],
            key: 'dispatchDate',
            entity: 'keys.dispatch_date',
            namespace: nsSimCard,
            type: 'dateNoTime'
        },
        POS_TERMINAL: {
            parentKeys: ['sim'],
            key: 'posTerminal',
            entity: 'simCard_posTerminal',
            type: 'text',
            MERCHANT: {
                parentKeys: ['sim', 'posTerminal'],
                key: 'merchant',
                type: 'text',
                entity: 'simCard_posTerminal_merchant'
            },
            UUID: {
                parentKeys: ['sim', 'posTerminal'],
                key: 'uuid'
            },
            DIRECT_PROVIDER: {
                parentKeys: ['sim', 'posTerminal'],
                key: 'directProvider',
                type: 'text',
                entity: 'simCard_posTerminal_directProvider'
            },
            SERIAL_NUMBER: {
                parentKeys: ['sim', 'posTerminal'],
                key: 'serialNumber',
                type: 'text',
                entity: 'keys.serial_number',
                namespace: 'terminal',
                placeholder: 'filter.placeholder.serial_number',
                filter: 'input',
                enableSorting: true,
                isNested: true
            },
            MANUFACTURER: {
                parentKeys: ['sim', 'posTerminal'],
                key: 'manufacturer',
                type: 'text',
                entity: 'keys.manufacturer',
                namespace: 'terminal',
                placeholder: 'filter.placeholder.manufacturer',
                filter: 'input',
                enableSorting: true,
                isNested: true
            },
            STATUS_TPE: {
                parentKeys: ['sim', 'posTerminal'],
                key: 'status',
                entity: 'simCard_posTerminal_status',
                type: 'select'
            },
            STATUS_SUBSCRIPTION: {
                parentKeys: ['sim', 'posTerminal'],
                key: 'subscriptionStatus',
                entity: 'simCard_posTerminal_subscription_status',
                type: 'select'
            },
            LAST_GPRS_CALL: {
                parentKeys: ['sim', 'posTerminal'],
                key: 'lastGprsCall',
                type: 'date',
                entity: 'keys.last_gprs_call',
                namespace: 'terminal',
                filter: 'date',
                enableSorting: true,
                isNested: true
            },
            LAST_IP_CALL: {
                parentKeys: ['sim', 'posTerminal'],
                key: 'lastIpCall',
                type: 'date',
                entity: 'simCard_posTerminal_IP_last_connection'
            }
        },
        DATA_USAGE: {
            parentKeys: ['sim'],
            key: 'dataUsage',
            type: 'chart',
            entity: 'keys.data_usage',
            namespace: nsSimCard,
            placeholder: 'filter.placeholder.data_usage',
            tooltip: 'tooltip.data_usage',
            filter: 'number',
            enableSorting: true,
            isNested: true
        },
        LAST_COMM_DATE: {
            parentKeys: ['sim'],
            key: 'lastCommunicationDate',
            entity: 'keys.last_comm_date',
            namespace: nsSimCard,
            type: 'date'
        },
        FIRST_COMM_DATE: {
            parentKeys: ['sim'],
            key: 'firstCommunicationDate',
            entity: 'keys.first_comm_date',
            namespace: nsSimCard,
            type: 'date'
        },
        END_OF_ENGAGEMENT_DATE: {
            parentKeys: ['sim'],
            key: 'endOfEngagementDate',
            entity: 'keys.end_engagement_date',
            namespace: nsSimCard,
            type: 'dateNoTime'
        },
        SUSPENSION_DATE: {
            parentKeys: ['sim'],
            key: 'suspensionDate',
            entity: 'keys.suspension_date',
            namespace: nsSimCard,
            type: 'dateNoTime'
        },
        NEXT_OFFER: {
            parentKeys: ['sim'],
            key: 'nextOffer',
            entity: 'simCard_next_offer',
            type: 'text'
        },
        NEXT_ICCID: {
            parentKeys: ['sim'],
            key: 'nextIccid',
            entity: 'simCard_next_iccid',
            type: 'text'
        },
        OFFER_CAN_BE_UPDATED: {
            parentKeys: ['sim'],
            key: 'offerCanBeUpdated',
            entity: 'simCard_offer_can_be_updated',
            type: 'text'
        },
        PROVIDER: {
            parentKeys: ['sim'],
            key: 'provider',
            type: 'text'
        }
    },
    DETAILS: {
        key: 'details',
        enableSorting: false
    },
    SIM_OFFERS: {
        key: 'simOffers',
        UUID: {
            parentKeys: ['simOffers'],
            key: 'uuid'
        },
        DATA: {
            parentKeys: ['simOffers'],
            key: 'data'
        },
        DATA_UNIT: {
            parentKeys: ['simOffers'],
            key: 'dataUnit'
        },
        DISPLAY_NAME: {
            parentKeys: ['simOffers'],
            key: 'displayName',
            altKey: 'name'
        },
        PROVIDER_OFFER_NAME: {
            parentKeys: ['simOffers'],
            key: 'providerOfferName'
        },
        RANK: {
            parentKeys: ['simOffers'],
            key: 'rank'
        },
        SHORT_DISPLAY_NAME: {
            parentKeys: ['simOffers'],
            key: 'shortDisplayName'
        },
        SIM_PROVIDER_NAME: {
            parentKeys: ['simOffers'],
            key: 'simProviderName'
        }
    },
    SIM_PROVIDERS: {
        key: 'simProviders',
        PROVIDER_NAME: {
            parentKeys: ['simProviders'],
            key: 'providerName'
        },
        QUANTITIES: {
            parentKeys: ['simProviders'],
            key: 'quantities'
        }
    }
};